import { ArrowRight } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { StepShell } from "./StepShell";
import { OptionGrid } from "./OptionGrid";

export const StepTools = ({ onNext, onBack }) => {
  const { state, update, meta } = useAdvisor();

  const toggle = (k) => {
    if (k === "none") return update({ tools: state.tools.includes("none") ? [] : ["none"] });
    const base = state.tools.filter((x) => x !== "none");
    update({ tools: base.includes(k) ? base.filter((x) => x !== k) : [...base, k] });
  };

  return (
    <StepShell
      testid="advisor-step-tools" step={2} total={2} onBack={onBack}
      title="Hazırda nədən istifadə edirsiniz?" subtitle="Bir neçə variant seçə bilərsiniz"
      footer={
        <button className="adv-btn w-full" disabled={!state.tools.length} onClick={onNext} data-testid="btn-step2-analyze">
          Mənə həll təklif et <ArrowRight className="h-5 w-5" />
        </button>
      }
    >
      <OptionGrid options={meta?.tools || []} value={state.tools} onToggle={toggle} prefix="tool-checkbox" cols="grid-cols-1 sm:grid-cols-2" />
    </StepShell>
  );
};
